"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/TokenLoader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _types = require('web/screens/Signup/types');
var _useStatefulPromise = require('shared/hooks/useStatefulPromise');

var _components = require('web/screens/Signup/components');
var _Spinner = require('web/components/Spinner');
var _signupAttribution = require('web/services/signupAttribution');
var _TokenError = require('./TokenError'); var _TokenError2 = _interopRequireDefault(_TokenError);
var _SetupFlow = require('./SetupFlow'); var _SetupFlow2 = _interopRequireDefault(_SetupFlow);







const isTokenInvalid = (status) =>
  status === _types.WelcomeUserInvalidStatus.SERVER_ERROR
    || status === _types.WelcomeUserInvalidStatus.TOKEN_USED
    || status === _types.WelcomeUserInvalidStatus.ACTIVE
    || status === _types.WelcomeUserInvalidStatus.INVALID_TOKEN
    || status === _types.WelcomeUserInvalidStatus.TOKEN_EXPIRED
    || status === _types.WelcomeUserInvalidStatus.UNVERIFIED_EMAIL

const TokenLoader = ({ token, onValidateToken, onSubmitSetup }) => {
  const [welcomeUser, setWelcomeUser] = _react.useState(null)
  const loadWelcomeUser = _react.useCallback.call(void 0, 
    async () => {
      if (token) return onValidateToken(token).then(setWelcomeUser)
    },
    [token, onValidateToken],
  )
  const { isLoading, hasFailed, run } = _useStatefulPromise.useStatefulPromise.call(void 0, loadWelcomeUser)
  // A failed check shows the "Something went wrong" card below.
  _react.useEffect.call(void 0, 
    () => {
      run().catch(() => undefined)
    },
    [run],
  )
  _react.useEffect.call(void 0, 
    () => {
      if (_optionalChain([welcomeUser, 'optionalAccess', _ => _.Email])) _signupAttribution.identifySignupEmail.call(void 0, welcomeUser.Email)
    },
    [welcomeUser],
  )

  if (isLoading) {
    return (
      _react2.default.createElement(_components.SignupStepWrapper, { showProgress: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        , _react2.default.createElement('div', { className: "auth-stack auth-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
          , _react2.default.createElement(_Spinner.SimpleSpinner, { className: "auth-loading--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Checking your sign-up link…"   )
        )
      )
    )
  }

  if (hasFailed || !token || !welcomeUser || isTokenInvalid(welcomeUser.Status)) {
    const tokenStatus = _optionalChain([welcomeUser, 'optionalAccess', _2 => _2.Status]) 
      || _types.WelcomeUserInvalidStatus.SERVER_ERROR

    return (
      _react2.default.createElement(_components.SignupStepWrapper, { showProgress: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        , _react2.default.createElement(_TokenError2.default, { tokenStatus: tokenStatus, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
      )
    )
  }

  return (
    _react2.default.createElement(_SetupFlow2.default, {
      token: token,
      welcomeUser: welcomeUser,
      onSubmitSetup: onSubmitSetup, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
    )
  )
}

exports. default = TokenLoader
